"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var $ = require("jquery");
require("jquery-ui");
var moment = require("moment");
var config_1 = require("../config");
var DatePickerWrapper = (function (_super) {
    __extends(DatePickerWrapper, _super);
    function DatePickerWrapper(props) {
        var _this = _super.call(this, props) || this;
        _this.datepickerRef = React.createRef();
        return _this;
    }
    DatePickerWrapper.prototype.componentDidMount = function () {
        var self = this;
        $(self.datepickerRef.current).datepicker({
            showButtonPanel: true,
            dateFormat: dateFormat,
            onClose: function () { self.onUserInput(); },
        });
        if (self.props.autofocus) {
            $(self.datepickerRef.current).focus();
        }
    };
    DatePickerWrapper.prototype.onUserInput = function () {
        var self = this;
        var val = $(self.datepickerRef.current).val();
        if (!val) {
            self.props.onChange(null);
            return;
        }
        var tmpMoment = moment(val, config_1.ISO_DATE_FORMAT).startOf('day');
        self.props.onChange(tmpMoment);
    };
    DatePickerWrapper.prototype.shouldComponentUpdate = function () {
        return false;
    };
    DatePickerWrapper.prototype.render = function () {
        return (React.createElement("div", null,
            React.createElement("input", { type: "text", ref: this.datepickerRef, className: "form-control", name: this.props.name, id: this.props.id, defaultValue: this.props.selected ? this.props.selected.format(config_1.ISO_DATE_FORMAT) : null, autoComplete: "off" })));
    };
    return DatePickerWrapper;
}(React.Component));
exports.default = DatePickerWrapper;
